var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgHeartReferti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.237,
    height: 23.581,
    viewBox: "0 0 25.237 23.581",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_5489",
    "data-name": "Tracciato 5489",
    d: "M28.944,9.2a7.765,7.765,0,0,0-10.323-.533A7.746,7.746,0,0,0,7.008,18.511h3.759l3.9-6.76,2.553,7.742,2.861-5.077,2.412,4.124h2.3a.842.842,0,1,1,0,1.683H21.539L20.108,17.81,16.8,23.617l-2.581-7.77-2.5,4.348H8.3L18.621,30.517,29,20.138A7.746,7.746,0,0,0,28.944,9.2Z",
    transform: "translate(-5.997 -6.936)",
    fill: "#255300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgHeartReferti);
export default __webpack_public_path__ + "static/media/SvgHeartReferti.1d4743eb50602cd8381680a6a8f471b5.svg";
export { ForwardRef as ReactComponent };